import React from "react";
import {
    Dialog,
    DialogContent,
    Box,
    IconButton,
    Typography,
    CircularProgress
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";

const VisualizarPDF = ({
    open,
    onClose,
    pdfUrl,
    nomeArquivo
}) => {


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    width: {
                        xs: "100%",
                        sm: "95%",
                        md: "90%"
                    },

                    height: {
                        xs: "100%",
                        sm: "95vh"
                    },

                    maxHeight: "95vh",

                    borderRadius: {
                        xs: 0,
                        sm: "18px"
                    },

                    overflow: "hidden",

                    boxShadow: "0 20px 60px rgba(0,0,0,0.20)"
                }
            }}
        >

            {/* HEADER */}

            <Box
                sx={{
                    height: "64px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: {
                        xs: 2,
                        md: 3
                    },

                    borderBottom: "1px solid #EDEDED",
                    backgroundColor: "#FFFFFF"
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.2
                    }}
                >

                    <Box
                        sx={{
                            width: 38,
                            height: 38,
                            borderRadius: "10px",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            backgroundColor: "#F7E8FA",
                            color: "#9C01B9"
                        }}
                    >
                        <PictureAsPdfRoundedIcon />
                    </Box>

                    <Box>

                        <Typography
                            sx={{
                                fontSize: {
                                    xs: "14px",
                                    md: "15px"
                                },

                                fontWeight: 700,
                                color: "#171717",

                                maxWidth: {
                                    xs: "170px",
                                    sm: "400px"
                                },

                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}
                        >
                            {nomeArquivo || "Visualização do documento"}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: "12px",
                                color: "#858585"
                            }}
                        >
                            Documento contábil
                        </Typography>

                    </Box>

                </Box>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5
                    }}
                >


                    <IconButton
                        onClick={onClose}
                        sx={{
                            color: "#666666",

                            "&:hover": {
                                backgroundColor: "#F5F5F5"
                            }
                        }}
                    >
                        <CloseRoundedIcon />
                    </IconButton>

                </Box>

            </Box>

            {/* PDF */}

            <DialogContent
                sx={{
                    p: 0,
                    backgroundColor: "#525252",
                    position: "relative",
                    overflow: "hidden"
                }}
            >

                {!pdfUrl && (
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",

                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",

                            gap: 2
                        }}
                    >

                        <CircularProgress
                            size={35}
                            sx={{
                                color: "#9C01B9"
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#FFFFFF",
                                fontSize: "14px"
                            }}
                        >
                            Carregando documento...
                        </Typography>

                    </Box>
                )}

                {pdfUrl && (
                    <iframe
                        src={pdfUrl}
                        title={nomeArquivo || "Documento PDF"}
                        width="100%"
                        height="100%"
                        style={{
                            border: "none",
                            display: "block"
                        }}
                    />
                )}

            </DialogContent>

        </Dialog>
    );
};

export default VisualizarPDF;